import { readCid, stripCid } from "@libs/rudderstack/cid";
import { setSessionAttribution, track } from "@utils/rudderstack";
import { useEffect } from "react";

/**
 * Web variant (app.lissen.com) of the link-tracking ingest (LIS-110) —
 * journey B's landing. A ?cid arrives on the document URL via the
 * open.lissen.com 302; ingest it once on mount: it becomes the session
 * attribution (every subsequent event carries session_cid), fires
 * link_web_landing, and is stripped from the address bar so copied URLs stay
 * clean — an organic copy simply mints no cid. ("View in app" re-appends the
 * session cid so an install hop still carries it.)
 */
const LinkTrackingHandler = () => {
  useEffect(() => {
    const { pathname, search, hash } = window.location;
    const cid = readCid(search);
    if (!cid) return;

    setSessionAttribution({ cid });
    track("link_web_landing", { cid });

    window.history.replaceState(
      window.history.state,
      "",
      stripCid(`${pathname}${search}${hash}`),
    );
  }, []);

  return null;
};

export default LinkTrackingHandler;
